module.exports = __webpack_public_path__ + "img/tualet.d489e425.svg";